// @ts-nocheck
/**
 * styleDefaults.ts — Shared StyleBlock / RenderChrome defaults.
 */

/** Applied when StyleBlock.padding is omitted (legacy templates + new components). */
export const DEFAULT_STYLE_PADDING = {
  top: 1,
  right: 2,
  bottom: 1,
  left: 2,
} as const;
